module.exports = "/_next/static/images/cto-364f7adb4ba71b6fcbcb0c430ae9a9bf.jpg";